import React, { Fragment } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import SeoStaticPagesTable from "./SeoStaticPagesTable";

const SeoStaticPages = () => (
  <Fragment>
    <Container fluid style={{ paddingTop: "30px" }}>
      <Row>
        <Col sm="12">
          <Card>
            <SeoStaticPagesTable />
          </Card>
        </Col>
      </Row>
    </Container>
  </Fragment>
);

export default SeoStaticPages;
